import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-context-clipboard',
    templateUrl: './icon-context-clipboard.component.html',
    styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconContextClipboardComponent {
    @Input() isActive: boolean = false;
}
